import * as React from 'react'
import clsx from 'clsx'
import { makeStyles } from 'tss-react/mui'
import { classToFComponent, FCClassContext, ToolbarDividerLegacy } from 'src/utils/views'

import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import { HeaderScope } from '../rd_scopes'

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: 5,
        marginLeft: 5
    },
    subheader: {
        fontSize: 12
    }
}))

type HeaderProps = {
    className?: string
    scope: HeaderScope
}

class HeaderViewClass implements FCClassContext<HeaderProps> {
    // :: Fields

    scope!: HeaderScope

    // :: Emissors

    // <EMPTY>

    // :: Methods

    onSyncState({ scope }: HeaderProps) {
        this.scope = scope
    }

    render(props: HeaderProps): React.JSX.Element {
        const classes = useStyles().classes

        return (
            <div className={clsx(classes.view, props.className)}>
                <ToolbarDividerLegacy orientation="vertical" variant="middle" flexItem />
                <Stack
                    sx={{
                        justifyContent: 'center'
                    }}
                >
                    <Typography variant="h6">RD Station :: Integração</Typography>
                </Stack>
            </div>
        )
    }
}
export const HeaderView = classToFComponent(HeaderViewClass, React)
export default HeaderView
